import { createReducer, on } from '@ngrx/store';
import { LocationAllowedOsUpdatesApiActions } from './location-allowed-os-updates.actions';
import { adapter, initialState } from './location-allowed-os-updates.state';

export const LocationAllowedOsUpdateFeatureKey = 'LocationAllowedOsUpdates';

export const LocationAllowedOsUpdateReducer = createReducer(
  initialState,
  on(LocationAllowedOsUpdatesApiActions.updated, (state, { categoryId, categoryAllowedOsUpdates }) => {
    const stateEmpty = adapter.removeMany((x) => x.categoryId == categoryId, state);
    return adapter.upsertMany(categoryAllowedOsUpdates, stateEmpty);
  }),
  on(LocationAllowedOsUpdatesApiActions.loaded, (state, { categoryAllowedOsUpdates }) =>
    adapter.upsertMany(categoryAllowedOsUpdates, state)
  )
);

const { selectIds, selectEntities, selectAll } = adapter.getSelectors();

export const selectLocationAllowedOsUpdateIds = selectIds;

export const selectLocationAllowedOsUpdateEntities = selectEntities;

export const selectLocationAllowedOsUpdates = selectAll;
